<script setup lang="ts">
    const { id = 'default-id', validationErrors = [] } = defineProps<{
        id?: string;
        validationErrors?: string[];
    }>();
    const { t } = useI18n();
</script>

<template>
    <template v-if="validationErrors?.length > 0">
        <div
            v-for="error in validationErrors"
            :id="`error-${id}`"
            :key="error"
            class="error"
        >
            {{ t(error) }}
        </div>
    </template>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/form/form-errors.scss';
</style>
